import { Injectable } from "@angular/core";
import { CommonService } from "./common.service";
import { DbService } from "./db.service";
import { take } from "rxjs";
import { Notifications } from "src/app/models/notifications";
import { PushService } from "./push.service";

@Injectable({
  providedIn: "root",
})
export class AlarmService {
  constructor(
    private db: DbService,
    private commonService: CommonService,
    private pushService: PushService
  ) { }

  /**
   *
   * @param title 알람 제목
   * @param content 알람 내용
   * @param uuid 받는사람 uuid
   * @param link 알람 클릭시 이동 경로
   */

  // 알림 업데이트
  async notificationUpdate(uuid: string, title: string) {
    const id = this.commonService.generateFilename();
    await this.db.updateAt(`notifications/${id}`, {
      id: id,
      uuid: uuid,
      title: title,
      dateCreated: new Date().toISOString(),
      readSwitch: false,
    });
  }

  // 공지사항에 대한 내용
  // 새로운 공지사항이 입력이 된다면 pushSwitch가 true인 것만 앱내 알림으로 전송
  noticeSystem(obj) {
    this.db
      .collection$(`members`, (ref) =>
        ref
          .where("exitSwitch", "==", false)
          .where("pushSwitch", "==", true)
          .where("suspendSwitch", "==", false)
      )
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            const id = this.commonService.generateFilename();

            let notification: Notifications = {
              id,
              uuid: ele.uuid,
              dateCreated: obj.dateCreated,
              title: obj.title,
              content: obj.content,
              readSwitch: false,
              url: obj.url,
            };

            await this.db
              .updateAt(`notifications/${notification.id}`, notification)
              .then(() => {
                if (ele.pushId.length > 0) {
                }
              });
          }
        }
      });
  }

  // 한명의 회원 알림 푸쉬x
  memberSend(obj) {
    this.db
      .collection$(`members`, (ref) =>
        ref.where("exitSwitch", "==", false).where("uuid", "==", obj.uuid)
      )
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            await this.db.updateAt(`notifications/${obj.id}`, obj);
          }
        }
      });
  }

  // 회원 푸시, 알림 전송
  memberPush(obj, uuid, url) {
    this.db
      .collection$(`members`, (ref) => ref.where("exitSwitch", "==", false)
        .where("pushSwitch", "==", true).where("uuid", "==", uuid)
      )
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            const id = this.commonService.generateFilename();
            let notification: Notifications = {
              id,
              uuid: ele.uuid,
              dateCreated: new Date().toISOString(),
              title: obj.title,
              content: obj.content,
              url: url,
              readSwitch: false,
            };
            await this.db
              .updateAt(`notifications/${notification.id}`, notification)
              .then((res) => {
                console.log("res", res);

                if (ele.pushId.length > 0) {
                  this.pushService.sendPush(ele.pushId, obj);
                }
              });
          }
        }
      });
  }

  async plantMemberPush(obj, uuid, url, type, id) {
    let collectionPath, queryFn;

    if (type === 'write') {
      collectionPath = 'members';
      queryFn = (ref) => ref.where("exitSwitch", "==", false)
                            .where("pushSwitch", "==", true)
                            .where("uuid", "==", uuid);
    } else {
      collectionPath = 'notifications';
      queryFn = (ref) => ref.where("uuid", "==", uuid)
                            .where("url", "==", url)
                            .where("id", "==", id);
    }

    this.db.collection$(collectionPath, queryFn)
      .pipe(take(1))
      .subscribe(async (records: any) => {
        if (records && records.length > 0) {
          for await (let record of records) {
            let notification;
            if (type === 'write') {
              notification = {
                id: obj.id,
                uuid: record.uuid,
                dateCreated: new Date().toISOString(),
                title: obj.title,
                content: obj.content,
                url: url,
                readSwitch: false,
              };
              await this.db.updateAt(`notifications/${notification.id}`, notification)
                .then((res) => {
                  console.log("Created notification", res);

                  if (record.pushId.length > 0) {
                    this.pushService.sendPush(record.pushId, obj);
                  }
                });
            } else {
              record.title = obj.title;
              record.content = obj.content;
              record.dateCreated = new Date().toISOString();
              await this.db.updateAt(`notifications/${record.id}`, record)
                .then((res) => {
                  console.log("Updated notification", res);
                });
            }
          }
        }
      });
  }

  // //전체 알림 업데이트
  // async notificationUpdateAll( title: string) {
  //   const id = this.commonService.generateFilename();
  //   await this.db.updateAt(`notifications/${id}`, {
  //     id: id,
  //     title: title,
  //     uuid: uuid,
  //     dateCreated: new Date().toISOString(),
  //     badgeSwitch: false,
  //   });
  // }
}
